<ngx-loading [show]="loading" [config]="{backdropBorderRadius: '14px'}"></ngx-loading>
<nb-layout>
  <nb-layout-header>
    <ngx-header></ngx-header>
  </nb-layout-header>
  <nb-layout-column>
    <section class="content-sectiton">
      <div class="container">
        <div class="login-signup alert-msg">
          <header class="login-header">
            <h2 class="text-white">Forgot your password?</h2>
          </header>
          <form [formGroup]="emailDetail" (ngSubmit)="resetPassword()">
            <ul>
              <li>
                <p>
                  If you can't login in to your box, your easiest option is to visit the Forgot password page to reset
                  your password
                </p>
              </li>
              <li>
                <mat-form-field class="full-width">
                  <input type="email" matInput formControlName="email" placeholder="Email">
                </mat-form-field>
                <div *ngIf="emailDetail.controls.email.touched && emailDetail.controls.email.errors" class="error">
                  <div *ngIf="emailDetail.controls.email.errors.required">
                    <div class="alert custom-alert-danger" role="alert">
                      <span class="sr-only">Error:</span>
                      Email is required
                    </div>
                  </div>
                  <div *ngIf="emailDetail.controls.email.errors.pattern">
                    <div class="alert custom-alert-danger" role="alert">
                      <span class="sr-only">Error:</span>
                      Email must be a valid email address
                    </div>
                  </div>
                </div>
                <div *ngIf="emailError && !emailDetail.controls.email.errors">
                    <div class="alert custom-alert-danger" role="alert">
                      <span class="sr-only">Error:</span>
                      Please Enter Registered Email. 
                    </div>
                  </div>
              </li>
              <li>
              </li>
              <li>
                <input type="submit" name="submit" value="Submit">
              </li>
            </ul>
          </form>
        </div>
      </div>
    </section>
  </nb-layout-column>
  <nb-layout-footer>
    <ngx-footer></ngx-footer>
  </nb-layout-footer>
</nb-layout>